const MuiPickersToolbarText = {
  toolbarBtnSelected: {
    color: '#ffffff',
  },
};

export default MuiPickersToolbarText;
